import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import DynamicForm, { withExtension } from 'components/Shared/DynamicForm';
import ContractsSchema from 'schemas/contracts.schema.json';
import { useAppContext } from 'hooks/useAppContext';
import { useAuthContext } from 'hooks/useAuthContext';
import { addContracts, updateContracts } from 'utils/ContractsUtils';
import ODataUtil from 'utils/ODataUtil';
import { useFormContext } from 'hooks/useFormContext';
import SkeletonForm from 'components/Shared/SkeletonForm';

const ContractsForm = ({ orientation, defaultValues, CRUDType, callback, disabledProperties, hiddenProperties: _hiddenProperties, type = null }) => {
  _hiddenProperties = [];
  const [hiddenProperties, setHiddenProperties] = useState(_hiddenProperties);
  defaultValues = ODataUtil.unCoupleExpandsFromDefaults(defaultValues);

  // contact specific logic
  const { selectedProject, selectedProjectData } = useAppContext();
  const authContext = useAuthContext();
  const formContext = useFormContext();

  useEffect(() => {
    !formContext.schema && formContext.updateSchema(ContractsSchema);
  })

  if (authContext.systemUserId) {
    defaultValues["CreatorSystemUserId"] = authContext.systemUserId;
  }

  if (CRUDType === "INSERT") {
    defaultValues['IsActive'] = true && disabledProperties.push('IsActive');
    if (selectedProjectData) {
      // defaultValues["OrganizationId"] = selectedProjectData && selectedProjectData.OrganizationId;
      hiddenProperties.push("IsActive");
    };
  }
  if (CRUDType === "UPDATE") {
    defaultValues['IsActive'] = defaultValues['IsActive'];
    disabledProperties = [];
  };

  hiddenProperties.push("CreatorSystemUserId");

  useEffect(() => {
    function updateSchemaForExclusivity() {
      // only allow the user to set org or contractor;
      if (type === "Organization") {
        setHiddenProperties(hp => [...hp, "ContractorId"]);
        formContext.updateSchema({
          ...formContext.schema,
          properties: {
            ...formContext.schema.properties,
            OrganizationId: { ...formContext.schema.properties.OrganizationId, required: true },
            ContractorId: { ...formContext.schema.properties.ContractorId, required: false }
          }
        });
      } else if (type === "Contractor") {
        setHiddenProperties(hp => [...hp, "OrganizationId"]);
        formContext.updateSchema({
          ...formContext.schema,
          properties: {
            ...formContext.schema.properties,
            ContractorId: { ...formContext.schema.properties.ContractorId, required: true },
            OrganizationId: { ...formContext.schema.properties.OrganizationId, required: false }
          }
        });
      };

      if (defaultValues.OrganizationId) {
        setHiddenProperties(hp => [...hp, "ContractorId"]);
      } else if (defaultValues.ContractorId) {
        setHiddenProperties(hp => [...hp, "OrganizationId"]);
      };
    }

    formContext.ready && updateSchemaForExclusivity();
  }, [defaultValues.ContractorId, defaultValues.OrganizationId, formContext, type]);

  // contact specific CRUD functions
  const onSubmit = async (values) => {
    let result;
    if (CRUDType === "INSERT") {
      result = await addContracts(selectedProject, values, authContext.systemUserId);
    } else if (CRUDType === "UPDATE") {
      result = await updateContracts(defaultValues.ContractId, values);
    };

    if (result.success) {
      setTimeout(callback, 1000);
    }

    return result;
  };

  const Form = () => withExtension(DynamicForm, {
    schema: formContext.schema, orientation: "Horizontal", onSubmit,
    defaultValues, disabledProperties, hiddenProperties, definitions: formContext.definitions
  });
  /* 
  on rare occasions, this component may be reached before the full AppContext is done initializing.
  so this form only renders when there is data in selectedProjectData     
  */
  return (
    <div style={{ maxWidth: "100%", padding: 16 }}>
      {selectedProjectData && formContext.ready ? <Form /> : <SkeletonForm />}
    </div>
  )

}



ContractsForm.propTypes = {
  orientation: PropTypes.string,
  defaultValues: PropTypes.object,
  CRUDType: PropTypes.oneOf(['INSERT', 'UPDATE']).isRequired,
  callback: PropTypes.func,
  disabledProperties: PropTypes.array,
  hiddenProperties: PropTypes.array
}

ContractsForm.defaultProps = {
  orientation: "Vertical",
  callback: () => { },
  defaultValues: {},
  disabledProperties: [],
  hiddenProperties: []
}


export default ContractsForm
